import { memo, useEffect } from "react";
import { useScriptIsEnabled } from "../hooks/useScriptIsEnabled";
import { useUserInfo, useUserInfoStore } from "../store/useUserInfo";
const APPCUES_SDK_URL = "https://fast.appcues.com/123720.js";
export const ConnectAppcues = memo(() => {
    const isEnabled = useScriptIsEnabled("appcues");
    useEffect(() => {
        useUserInfo.action();
    }, []);
    useEffect(() => {
        if (isEnabled) {
            window.AppcuesSettings = { enableURLDetection: true };
            if (typeof window.Appcues === "undefined") {
                const script = document.createElement("script");
                script.src = APPCUES_SDK_URL;
                script.onload = function () {
                    const userInfo = useUserInfoStore.getState().userInfo?.results;
                    if (userInfo) {
                        window?.Appcues.identify(userInfo.userId, {
                            name: userInfo.full_name,
                            email: userInfo.email,
                        });
                    }
                };
                document.head.appendChild(script);
            }
        }
    }, [isEnabled]);
    return null;
});
